import { createContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { APISERVICE } from '../../../services/api.service'
import { TableSubject } from './TableSubject'
import { ModalSubject } from './ModalSubject'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

export const ContextSubject = createContext(null)

export function EnableSubject() {
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [infoTeacher, setInfoTeacher] = useState([])
    const teacher = useSelector((store) => store.teacher)
    const [faculties, setFaculties] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [subjectSelected, setSubjectSelected] = useState([])
    const [selectedFaculty, setSelectedFaculty] = useState('')

    useEffect(() => {
        getFaculties()
        getInfoTeacher()
    }, [])

    const getInfoTeacher = async () => {
        setLoading(true)
        const url = 'docente/get-info-teacher?idTeacher='
        const params = id
        const response = await APISERVICE.get(url, params)
        groupSubject(response)
        // setInfoTeacher(response);
        setLoading(false)
    }
    const getFaculties = async () => {
        const url = 'facultad/all'
        const params = ''
        await APISERVICE.get(url, params).then((res) => {
            setFaculties(res)
            // setFaculties(
            //     res.faculty.reduce((carry, f) => {
            //         const key = `${f.gestion}-${f.periodo}`
            //         if (!carry[key]) carry[key] = []
            //         carry[key].push(f)
            //         return carry
            //     }, {}),
            // )
        })
    }
    const showModalSchedules = (facultyId, subject) => {
        setSubjectSelected(subject)
        setSelectedFaculty(facultyId)
        setShowModal(true)
    }
    const groupSubject = (subjects) => {
        const gruoupedSubjects = subjects.reduce((carry, value) => {
            const key = `${value.gestion}-${value.periodo}-${value.codigo}`
            if (!carry[key]) {
                carry[key] = []
            }
            carry[key].push(value)
            return carry
        }, {})
        const gruoupedSubjectArr = Object.values(gruoupedSubjects)
        setInfoTeacher(gruoupedSubjectArr)
    }

    const changeStateSchedule = async (body) => {
        if (subjectSelected && selectedFaculty) {
            const params = `idFaculty=${selectedFaculty}&idSubject=${subjectSelected[0].id}`
            const url = 'materia/change-state-schedules?'
            const { success, message } = await APISERVICE.post(url, params, {
                horarios: body,
            })
            if (success) {
                getInfoTeacher()
                toast.success(message)
                setSelectedFaculty('')
                setShowModal(false)
            } else {
                toast.error(message)
            }
        }
    }

    return (
        <ContextSubject.Provider value={{ setSubjectSelected, subjectSelected, showModalSchedules }}>
            <div className='contenedor pt-3'>
                <div className='mb-3' style={{fontSize: '1.25rem'}}>
                    <span className='fw-medium'>Docente:</span> {teacher.datos?.nombre}
                </div>
                <h5>Materias</h5>
                <TableSubject subjects={infoTeacher} faculties={faculties} loading={loading} />
                <ModalSubject
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    changeStateSchedule={changeStateSchedule}
                    setInfoTeacher={setInfoTeacher}
                    infoTeacher={infoTeacher}
                />
            </div>
        </ContextSubject.Provider>
    )
}
